<span *ngIf="tooltipOptions$ | async as tooltipOptions" class="horizontal-flex aic">
    <i class="dku-icon-warning-{{tooltipOptions.iconOptions.style}}-16 icon-{{tooltipOptions.iconOptions.status}}-color" [ngClass]="tooltipOptions.iconOptions.size" [matTooltip]="tooltipOptions.message"
    [matTooltipPosition]="tooltipOptions.position" [matTooltipClass]="tooltipOptions.class"></i>
</span>
